import React, { useEffect, useState } from 'react'
import { v2_products } from '../../../actions/v2/product';
import { validateFunctionalForm } from '../../../utils';

const Form = (props) => {
    const [state, setState] = useState({
        name: { name: 'name', value: props.data ? props.data.NAME : '', isRequired: true, error: '' },
        product: { name: 'product', value: props.data ? props.data.PRODUCT_ID : '', options: [], isRequired: true, error: '' },
        gstPercent: { name: 'gstPercent', value: props.data ? props.data.GST_PERCENT : '', options: [], isRequired: true, error: '' },
        otherDetails: { name: 'otherDetails', value: props.data ? props.data.DETAIL : '', isRequired: false, error: '' },
    })
    const onChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
                error: prevState[name].isRequired && !value ? 'This field is required' : ''
            }
        }));
    };
    const setOptions = (name, options) => {
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                options: options
            }
        }));
    };
    useEffect(() => {
        v2_products().then((res) => {
            if (res.status) {
                setOptions('product', res.result)
            }
        })
    }, [])

    const onSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {
                subProductName: state.name.value,
                productId: state.product.value,
                subProductDetail: state.otherDetails.value,
                gstPercent:state.gstPercent.value
            }
            if (props.data) {
                model.id = props.data.ID
            }
            props.onSubmit(model)
        }
    }
    return (
        <React.Fragment>
            <h4 className="card-title mb-4">{props.title}</h4>
            <div id="basic-example">
                <section>
                    <form onSubmit={onSubmit}>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-firstname-input">
                                        Product <span className='text-danger'>*</span>
                                    </label>
                                    <select
                                        className={state.product.error ? "form-select is-invalid" : "form-select"}
                                        id="basicpill-firstname-input"
                                        name={state.product.name}
                                        value={Number(state.product.value)}
                                        onChange={onChange}
                                    >
                                        <option value={''}>Select Product</option>
                                        {state.product.options.map((item) => {
                                            return (<option value={Number(item.ID)}>{item.NAME}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-Sub-Product-Name-input">
                                        Sub Product Name <span className='text-danger'>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={state.name.error ? "form-control is-invalid" : "form-control"}
                                        id="basicpill-Sub-Product-Name-input"
                                        placeholder="Enter Sub Product Name"
                                        name={state.name.name}
                                        value={state.name.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-gstPercent-Name-input">
                                        GST (in %) <span className='text-danger'>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={state.name.error ? "form-control is-invalid" : "form-control"}
                                        id="basicpill-gstPercent-Name-input"
                                        placeholder="GST (in %)"
                                        name={state.gstPercent.name}
                                        value={state.gstPercent.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-address-input">
                                        Other Details
                                    </label>
                                    <textarea
                                        id="basicpill-address-input"
                                        className={state.otherDetails.error ? "form-control is-invalid" : "form-control"}
                                        rows={2}
                                        placeholder="Enter Other Details"
                                        defaultValue={""}
                                        name={state.otherDetails.name}
                                        value={state.otherDetails.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <button
                                        type='submit'
                                        className="btn btn-success waves-effect btn-label waves-light me-2"
                                    >
                                        <i className="bx bx-check-double label-icon" />{" "}
                                        {props.buttonName}
                                    </button>
                                    <button
                                        type='reset'
                                        onClick={() => { props.onCancel() }}
                                        className="btn btn-danger waves-effect btn-label waves-light"
                                    >
                                        <i className="bx bx-block label-icon " /> Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </React.Fragment>

    )
}

export default Form